import { Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLink } from "ExternalLink";
import { ReactComponent as Link03Icon } from "components/Icons/link-03.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      display: "flex",
      flexDirection: "column",
    },
    header: {
      display: "flex",
      gap: theme.spacing(5),
    },
    title: {
      fontSize: 14,
      fontWeight: 500,
      color: "#222",
    },
    manuallyAssigned: {
      color: theme.gray500,
      fontSize: 14,
      fontWeight: 500,
    },
    desc: {
      color: theme.gray500,
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "20px",
      marginTop: theme.spacing(2),
    },
    link: {
      marginTop: theme.spacing(6),
      display: "flex",
      alignItems: "center",
      maxWidth: "100%",
      overflow: "hidden",
      "& svg": {
        width: "14px",
        flexShrink: 0,
        marginLeft: theme.spacing(2),
      },
      "& > span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
  }),
);

interface Props {
  title: string;
  isManuallyAssigned?: boolean;
}

export const TierTooltip = ({ title, isManuallyAssigned }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <Typography className={classes.title}>{title}</Typography>
        {isManuallyAssigned && (
          <Typography className={classes.manuallyAssigned}>
            ({message({ id: "manuallyAssigned" })})
          </Typography>
        )}
      </div>
      {isManuallyAssigned && (
        <>
          <div className={classes.desc}>
            {message({ id: "manuallyAssignedTierDescription" })}
          </div>
          <ExternalLink
            className={classes.link}
            path="https://help.openloyalty.io/main-features/tiers"
          >
            <span>{message({ id: "documentation" })}</span>
            <Link03Icon />
          </ExternalLink>
        </>
      )}
    </div>
  );
};
